<template>
  <a :href="link" :target="target" class="link-target">
    <span><slot></slot></span>
  </a>
</template>

<script>
export default {
  name: "LinkTarget",
  props: {
    link: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: '_blank'
    }
  }
}
</script>